import React, { memo } from 'react';
import ChartCard from '../ChartCard';
import { useTranslation } from 'react-i18next';

const LabelsChart = memo(({ data, chartView, setChartView, onZoomClick, dataLimit, setDataLimit, defaultExpanded = true, isPinned = false, onPin }) => {
  const { t } = useTranslation();
  return (
    <ChartCard
      title={t('reports.charts.labelsVsTicketCount')}
      data={data}
      chartView={chartView}
      setChartView={setChartView}
      onZoomClick={onZoomClick}
      chartHeight={350}
      dataLimit={dataLimit}
      setDataLimit={setDataLimit}
      chartType="labels"
      defaultExpanded={defaultExpanded}
      isPinned={isPinned}
      onPin={onPin}
    />
  );
}, (prevProps, nextProps) =>
  prevProps.data === nextProps.data &&
  prevProps.chartView === nextProps.chartView &&
  prevProps.dataLimit === nextProps.dataLimit &&
  prevProps.isPinned === nextProps.isPinned
);

export default LabelsChart;
